// import React, { useState } from 'react';
// import Modal from 'react-modal';
// import { Product } from '../../interfaces/adminproduct';
// import './ProductModal.css';
// import EntityDetailModal from './EntityDetailModal';
// import { fetchEntityById } from '../../graphql/api/cartApi';
// import * as FaIcons from "react-icons/fa";

// const FaFolder = FaIcons.FaFolder as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
// const FaUser = FaIcons.FaUser as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
// const FaStore = FaIcons.FaStore as unknown as React.FC<React.SVGProps<SVGSVGElement>>;


// Modal.setAppElement('#root');

// interface ProductModalProps {
//   isOpen: boolean;
//   onClose: () => void;
//   product: Product | null;
// }

// const ProductModal: React.FC<ProductModalProps> = ({ isOpen, onClose, product }) => {
//   const fieldStyle: React.CSSProperties = {
//     margin: '4px 0',
//     fontSize: '15px',
//     lineHeight: '1.4',
//   };

//   const sectionStyle: React.CSSProperties = {
//     marginTop: '16px',
//     paddingTop: '12px',
//     borderTop: '1px solid #eee',
//   };

//   const [modalData, setModalData] = useState<any>(null);
//   const [modalType, setModalType] = useState<'category' | 'vendor' | 'shop' | null>(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//  const fetchAndShowDetails = async (
//   type: 'category' | 'vendor' | 'shop',
//   id: string
// ) => {
//   try {
//     setModalType(type);
//     setIsModalOpen(true);

//     const data = await fetchEntityById(type, id);
//     setModalData(data);
//   } catch (error) {
//     console.error('⚠️ Error showing details:', error);
//   }
// };


//   return (
//     <Modal
//       isOpen={isOpen}
//       onRequestClose={onClose}
//       contentLabel="Product Details"
//       style={{
//         overlay: {
//           backgroundColor: 'rgba(0,0,0,0.5)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 1000,
//         },
//         content: {
//           position: 'relative',
//           background: '#fff',
//           padding: '24px',
//           borderRadius: '8px',
//           width: '90%',
//           maxWidth: '600px',
//           maxHeight: '90vh',
//           overflowY: 'auto',
//           boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
//           fontFamily: 'Segoe UI, sans-serif',
//         },
//       }}
//     >
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
//         <h2 style={{ margin: 0 }}>Product Details</h2>
//         <button
//           onClick={onClose}
//           style={{
//             background: '#e74c3c',
//             color: '#fff',
//             border: 'none',
//             borderRadius: '50%',
//             width: '32px',
//             height: '32px',
//             fontSize: '20px',
//             cursor: 'pointer',
//             lineHeight: 0,
//           }}
//         >
//           ×
//         </button>
//       </div>

//       {product ? (
//         <div>
          

//         <div className="product_modal_grid">
//               <div className="product_modal_image_wrapper">
//                {product.images?.[0] && (
//                   <img
//                     src={product.images[0]}
//                     alt={product.name}
//                     style={{
//                       width: '100%',
//                       maxHeight: '300px',
//                       objectFit: 'cover',
//                       marginBottom: '16px',
//                       borderRadius: '8px',
//                     }}
//                   />
//                 )}
//               </div>

//               <div className="product_modal_group">
//                 <div className="product_modal_row"><span className="label">ID:</span> <span>{product.id}</span></div>
//                 <div className="product_modal_row"><span className="label">Name:</span> <span>{product.name}</span></div>
//                 <div className="product_modal_row"><span className="label">Slug:</span> <span>{product.slug}</span></div>
//                 <div className="product_modal_row product_modal_description">
//                   <span className="label">Description:</span> 
//                   <p>{product.description}</p>
//                 </div>
//               </div>

//               <div className="product_modal_group">
//                 <div className="product_modal_price"><span>Vendor DP Price:</span> ₹{product.price}</div>
//                 <div className="product_modal_price">
//                   <span>Discount:</span> ₹{product.discountedPrice ?? 0}
//                 </div>
//                 <div className="product_modal_price"><span>Margin:</span> ₹{product.marginPrice}</div>
//                 <div className="product_modal_price">
//                   <span>Final Price:</span> ₹{(product.price + product.marginPrice) - (product.discountedPrice ?? 0)}
//                 </div>

//               </div>

//               <div className="product_modal_badges">
//                 <span className={`badge ${product.rewardFlag ? 'badge-success' : 'badge-gray'}`}>Reward: {product.rewardFlag ? 'Yes' : 'No'}</span>
//                 <span className="badge badge-orange">Status: {product.status}</span>
//                 <span className="badge badge-light">Currency: {product.currency}</span>
//                 <span className="badge badge-light">Stock: {product.stockQuantity}</span>
//               </div>

//              <div className="product-meta-group">

//                 <div className="meta-card category">
//                   <h4>
//                     <FaFolder className="txn_uid_icon" /> Category
//                   </h4>
//                   <span onClick={() => fetchAndShowDetails('category', product.categoryId)}>
//                     {product.categoryId}
//                   </span>
//                 </div>

//                 <div className="meta-card vendor">
//                   <h4>
//                     <FaUser className="txn_uid_icon" /> Vendor
//                   </h4>
//                   <span onClick={() => fetchAndShowDetails('vendor', product.vendorId)}>
//                     {product.vendorId}
//                   </span>
//                 </div>

//                 <div className="meta-card shop">
//                   <h4>
//                     <FaStore className="txn_uid_icon" /> Shop
//                   </h4>
//                   <span onClick={() => fetchAndShowDetails('shop', product.shopId)}>
//                     {product.shopId}
//                   </span>
//                 </div>

//               </div>



//       <EntityDetailModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         type={modalType!}
//         data={modalData}
//       />
//             </div>



//           <div style={sectionStyle}>
//             <strong>Attributes:</strong>
//             {product.attributes?.length > 0 ? (
//               <ul style={{ margin: '4px 0 0 1em', padding: 0 }}>
//                 {product.attributes.map((attr, index) => (
//                   <li key={index} style={{ marginBottom: '4px' }}>
//                     {attr.key}: {attr.value}
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               <p style={fieldStyle}>No attributes</p>
//             )}
//           </div>

//           <div style={sectionStyle}>
//             <strong>Variants:</strong>
//             {product.variants?.length > 0 ? (
//               <ul style={{ margin: '4px 0 0 1em', padding: 0 }}>
//                 {product.variants.map((variant, index) => (
//                   <li key={index} style={{ marginBottom: '12px' }}>
//                     <div style={{ marginBottom: '4px' }}>
//                       <em>Properties:</em>
//                       {variant.properties?.length > 0 ? (
//                         <ul style={{ marginTop: '4px', marginLeft: '1em' }}>
//                           {variant.properties.map((prop, i) => (
//                             <li key={i} style={{ marginBottom: '2px' }}>
//                               {prop.key}: {prop.value}
//                             </li>
//                           ))}
//                         </ul>
//                       ) : (
//                         <p style={fieldStyle}>No properties</p>
//                       )}
//                     </div>
//                     <div style={fieldStyle}>
//                       <em>Price:</em> ₹{variant.price}
//                     </div>
//                     <div style={fieldStyle}>
//                       <em>Stock Quantity:</em> {variant.stockQuantity}
//                     </div>
//                     {variant.sku && (
//                       <div style={fieldStyle}>
//                         <em>SKU:</em> {variant.sku}
//                       </div>
//                     )}
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               <p style={fieldStyle}>No variants</p>
//             )}
//           </div>
//         </div>
//       ) : (
//         <p style={fieldStyle}>No product selected.</p>
//       )}
//     </Modal>
//   );
// };

// export default ProductModal;
import React, { useState } from 'react';
import Modal from 'react-modal';
import { Product } from '../../interfaces/adminproduct';
import './ProductModal.css';
import EntityDetailModal from './EntityDetailModal';
import { fetchEntityById } from '../../graphql/api/cartApi';
import * as FaIcons from "react-icons/fa";

const FaFolder = FaIcons.FaFolder as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaUser = FaIcons.FaUser as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaStore = FaIcons.FaStore as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

Modal.setAppElement('#root');

interface ProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  product: Product | null;
}

const ProductModal: React.FC<ProductModalProps> = ({ isOpen, onClose, product }) => {

  const fieldStyle: React.CSSProperties = {
    margin: '4px 0',
    fontSize: '15px',
    lineHeight: '1.4',
  };

  const sectionStyle: React.CSSProperties = {
    marginTop: '16px',
    paddingTop: '12px',
    borderTop: '1px solid #eee',
  };

  const [modalData, setModalData] = useState<any>(null);
  const [modalType, setModalType] = useState<'category' | 'vendor' | 'shop' | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchAndShowDetails = async (
    type: 'category' | 'vendor' | 'shop',
    id: string
  ) => {
    try {
      setModalType(type);
      setIsModalOpen(true);
      const data = await fetchEntityById(type, id);
      setModalData(data);
    } catch (error) {
      console.error('⚠️ Error showing details:', error);
    }
  };

  // ✅ CORRECT PERCENTAGE CALCULATION
  const basePrice = product?.price ?? 0;
  const marginPercent = product?.marginPrice ?? 0;
  const discountPercent = product?.discountedPrice ?? 0;
  const gstPercent = product?.gst ?? 0;

  const priceWithMargin =
    basePrice + (basePrice * marginPercent) / 100;

  const priceAfterDiscount =
    priceWithMargin - (priceWithMargin * discountPercent) / 100;

  const finalPrice =
    priceAfterDiscount + (priceAfterDiscount * gstPercent) / 100;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Product Details"
      style={{
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        },
        content: {
          position: 'relative',
          background: '#fff',
          padding: '24px',
          borderRadius: '8px',
          width: '90%',
          maxWidth: '600px',
          maxHeight: '90vh',
          overflowY: 'auto',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          fontFamily: 'Segoe UI, sans-serif',
        },
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h2 style={{ margin: 0 }}>Product Details</h2>
        <button
          onClick={onClose}
          style={{
            background: '#e74c3c',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            fontSize: '20px',
            cursor: 'pointer',
            lineHeight: 0,
          }}
        >
          ×
        </button>
      </div>

      {product ? (
        <div>

          <div className="product_modal_grid">
            <div className="product_modal_image_wrapper">
              {product.images?.[0] && (
                <img
                  src={product.images[0]}
                  alt={product.name}
                  style={{
                    width: '100%',
                    maxHeight: '300px',
                    objectFit: 'cover',
                    marginBottom: '16px',
                    borderRadius: '8px',
                  }}
                />
              )}
            </div>

            <div className="product_modal_group">
              <div className="product_modal_row"><span className="label">ID:</span> <span>{product.id}</span></div>
              <div className="product_modal_row"><span className="label">Name:</span> <span>{product.name}</span></div>
              <div className="product_modal_row"><span className="label">Slug:</span> <span>{product.slug}</span></div>
              <div className="product_modal_row product_modal_description">
                <span className="label">Description:</span>
                <p>{product.description}</p>
              </div>
            </div>

            {/* 💰 PRICE SECTION (UI SAME — LOGIC FIXED) */}
            <div className="product_modal_group">
              <div className="product_modal_price"><span>Vendor DP Price:</span> ₹{product.price}</div>
              <div className="product_modal_price">
                <span>Discount:</span> {product.discountedPrice ?? 0}%
              </div>
              <div className="product_modal_price"><span>Margin:</span> {product.marginPrice}%</div>
              <div className="product_modal_price"><span>GST:</span> {product.gst ?? 0}%</div>

              <div className="product_modal_price">
                <span>Final Price:</span> ₹{finalPrice.toFixed(2)}
              </div>
            </div>

            <div className="product_modal_badges">
              <span className={`badge ${product.rewardFlag ? 'badge-success' : 'badge-gray'}`}>Reward: {product.rewardFlag ? 'Yes' : 'No'}</span>
              <span className="badge badge-orange">Status: {product.status}</span>
              <span className="badge badge-light">Currency: {product.currency}</span>
              <span className="badge badge-light">Stock: {product.stockQuantity}</span>
            </div>

            <div className="product-meta-group">

              <div className="meta-card category">
                <h4><FaFolder className="txn_uid_icon" /> Category</h4>
                <span onClick={() => fetchAndShowDetails('category', product.categoryId)}>
                  {product.categoryId}
                </span>
              </div>

              <div className="meta-card vendor">
                <h4><FaUser className="txn_uid_icon" /> Vendor</h4>
                <span onClick={() => fetchAndShowDetails('vendor', product.vendorId)}>
                  {product.vendorId}
                </span>
              </div>

              <div className="meta-card shop">
                <h4><FaStore className="txn_uid_icon" /> Shop</h4>
                <span onClick={() => fetchAndShowDetails('shop', product.shopId)}>
                  {product.shopId}
                </span>
              </div>

            </div>

            <EntityDetailModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              type={modalType!}
              data={modalData}
            />
          </div>

        </div>
      ) : (
        <p style={fieldStyle}>No product selected.</p>
      )}
    </Modal>
  );
};

export default ProductModal;
